import React, {Component} from 'react'
import ImageCard from '../ImageCard'

import './style.css'

class MultipleImageCards extends Component {
    render() {
        const props = this.props.data

        return (
            <div className='multiple-image-cards'>
                { this.props.data.map((item, index) => (
                    <ImageCard key={`image-card ${index}`} data={{
                        src: item.src,
                        title: item.title,
                        details: item.details
                    }} />
                ))}
            </div>
        )
    }
}

export default MultipleImageCards